export default class EmailFeedback {
    constructor(options) {
        this.appName = options.appName || "App";
        this.email = options.email || "jimmy@jdsoftwarellc.com";
        this.emailSubject = options.emailSubject || appName + " Feedback";
        this.os = options.os || this.getOS();
        this.version = options.version || "";
    }
    send(userdata) {

        let appName = this.appName;
        let os = this.os.substring(0,2);
        let email = this.email;
        let emailSubject = this.emailSubject;
        let version = this.version;
        let userId = userdata?.id;

        let url = `mailto:${email}?subject=${appName} ${version}-${os.substring(0,2)} ${emailSubject} ${userId} &body=`;
        url = encodeURI(url);
        window.open(url, "_system");
    }
   
    getOS() {
        let os = "unknown";

        var ua = navigator.userAgent;
        var isKindle = /Kindle|Silk|Amazon|KFDOWI|KFAPWA|KFSAW|KFGIWI|KFGIWI|KFAPW|KFARWI|KFTBWI|KFASWI|KFFOWI|KFJW|KFMEWI|KFOT|KFS‌​AW|KFSOWI|KFTBW|KFTH‌​W|KFTT|WFFOWI|KFJWA|KFJWI|KFTHWA|KFTHWI|KFAPWI|KFKAWI/i.test(ua);

        if (typeof FBInstant !== "undefined") {
            os = "FBMessenger";
            return os;
        }
        if (/(android)/i.test(navigator.userAgent) && isKindle) {
            os = "amazon";
        }
        else if (/(android)/i.test(navigator.userAgent) && !isKindle) {
            os = "android";
        }
        else if (/(ipod|iphone|ipad)/i.test(navigator.userAgent) || navigator.platform === 'MacIntel') {
            os = "ios";
        }
        else if (/(windows phone)/i.test(navigator.userAgent)) {
            os = "windows";
        }
        else if (/(windows)/i.test(navigator.userAgent)) {
            os = "windows";
        }
        return os;
    }
}